import { computed } from 'mobx';
import { TBlock } from '~/types/builder.types';
import { IServiceItemsContainerBlockResponse } from '~/types/server.types';
import { ContainerableBlock } from '~/models/blocks/containerable-block.model';
import type { ServiceSelectionBlock } from '~/models/blocks/service-selection-block.model';
import type { ServiceSelectionItemBlock } from '~/models/blocks/service-selection-item-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';
import { ServicesItemsLayoutType } from '~/types/model.types';

type ServiceItemContainerDataForServer = ReturnType<
    ContainerableBlock['getDataForServer']
> &
    Pick<IServiceItemsContainerBlockResponse, 'type'>;

export class ServiceItemsContainerBlock extends ContainerableBlock {
    type: 'service_items_container_block';

    constructor(
        block: IServiceItemsContainerBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get hoverable() {
        return false;
    }

    get isDeletable() {
        return false;
    }

    isDraggable() {
        return false;
    }

    dndAcceptedTypes() {
        return null;
    }

    @computed
    get shouldExpandOnSelect() {
        return false;
    }

    @computed
    get serviceItemBlocks() {
        return this.childBlocks as ServiceSelectionItemBlock[];
    }

    @computed
    get isContainerEmpty() {
        return this.serviceItemBlocks.length === 0;
    }

    @computed
    get isContainerFull() {
        const capacity = (() => {
            const layout = this.serviceSelectionBlock.services_layout;
            if (layout === ServicesItemsLayoutType.Rows) {
                return 1;
            }
            if (layout === ServicesItemsLayoutType.TwoColumns) {
                return 2;
            }
            return 3;
        })();
        return this.serviceItemBlocks.length === capacity;
    }

    @computed
    get serviceSelectionBlock(): ServiceSelectionBlock {
        let { parent } = this;

        while (parent && parent.type !== 'service_selection_block') {
            parent = parent.parent;
        }

        return parent as ServiceSelectionBlock;
    }

    canBeParentOf(block: TBlock) {
        return block.type === 'service_selection_item_block';
    }

    getDataForServer(): ServiceItemContainerDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'service_items_container_block'
        };
    }
}
